import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { ChangeReportConfigAlert } from "../../../components/reportConfig/ChangeReportConfigAlert";
import { ProbationConfigForm } from "../../../components/reportConfig/form/ProbationConfigForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Group } from "../../../models/group";
import type { ProbationConfiguration } from "../../../models/reportConfigs/probationConfiguration";
import type { YearContext } from "../../../models/yearContext";
import { report_configuration_path, report_configurations_path } from "../../../routes";

type ProbationConfigEditProps = {
  probation_config: ProbationConfiguration;
  year_contexts: YearContext[];
  groups: Group[];
  has_reports: boolean;
};

export default function ProbationConfigEdit({ year_contexts, groups, probation_config, has_reports }: ProbationConfigEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(report_configuration_path, probation_config.id), values);

  return (
    <ContentShell
      title={`Probezeibericht-Vorlage ${probation_config.title} bearbeiten`}
      onBack={() => router.get(pathWithYearContext(report_configurations_path))}
    >
      <ProbationConfigForm
        alert={has_reports && <ChangeReportConfigAlert />}
        probationConfig={probation_config}
        yearContexts={year_contexts}
        groups={groups}
        saveButtonLabel="Speichern"
        onSubmit={onSubmit}
      />
    </ContentShell>
  );
}
